// 게임 이벤트 관리 클래스
class GameEventManager {
  constructor(game) {
    this.game = game;
    this.setupEventListeners();
  }

  // 이벤트 리스너 설정
  setupEventListeners() {
    // 탭 전환 시 게임 자동 일시정지/재개
    document.addEventListener("visibilitychange", () => {
      if (!this.game) return;

      if (document.hidden) {
        // 탭이 숨겨지면 게임과 타이머 모두 일시정지
        if (this.game.gameLoop && this.game.gameLoop.getStatus().isRunning) {
          this.game.pause(true); // fromTab = true
          Utils.log("탭 전환으로 게임이 자동 일시정지되었습니다.");
        }
      } else {
        // 탭이 다시 보이면 게임과 타이머 재개 (단, 수동 일시정지가 아닌 경우만)
        if (this.game.gameLoop && !this.game.gameLoop.getStatus().isRunning) {
          this.game.resume(true); // fromTab = true (내부에서 수동 일시정지 체크)
          Utils.log("탭 복귀로 게임 재개를 시도합니다.");
        }
      }
    });

    // 웹 페이지 언로드 시 정리
    window.addEventListener("beforeunload", () => {
      if (this.game && this.game.gameLoop) {
        this.game.gameLoop.stop();
        Utils.log("게임 정리 완료");
      }
    });
  }

  // 이벤트 리스너 정리
  cleanup() {
    // 필요시 이벤트 리스너 제거
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }
}

// webpack 빌드를 위해 default export 추가
export default GameEventManager;